import { Component, OnInit } from '@angular/core';
import { SharedService } from 'app/shared.service';
import { AppHttpService } from '../../app-http.service';
import { CartService } from '../cart.service';

@Component({
  selector: 'app-lottery-main',
  templateUrl: './lottery-main.component.html',
  styleUrls: ['./lottery-main.component.scss']
})
export class LotteryMainComponent implements OnInit {
  lotteries = {
    products: []
  };

  constructor(
    private httpService: AppHttpService,
    private cartService: CartService,
    private sharedService: SharedService
  ) {
    this.getLotteries();
  }

  ngOnInit() {}

  getLotteries(): void {
    this.httpService.getLotteries().subscribe((response) => {
      this.lotteries = this.cartService.getProductsWithAmount(response);
      this.cartService.setLottery(response);
    });

    this.httpService.getMe().subscribe(
      (response) => {
        this.sharedService.setLoggedIn(true);
      },
      (error) => {
        this.sharedService.setLoggedIn(false);
      }
    );
  }
}
